<template>
  <v-row>
    <v-col cols="12" md="8" offset-md="2">
      <transition name="scroll-y-transition">
        <lean-list :records="records" :loading="loading" :datatype="datatype" />
      </transition>
      <lean-list-view-pagination :total="total" :datatype="datatype" @changePage="fetch" />
    </v-col>
  </v-row>
</template>

<script>
import LeanList from '@/components/LeanList.vue';
import { mapMutations, mapState } from 'vuex';
import { DatabaseAsleepError } from '@/helpers/databaseAsleepError';
import LeanListViewPagination from '@/components/LeanListViewPagination';

export default {
  name: 'LeanListView',
  components: { LeanListViewPagination, LeanList },
  data: function () {
    return {
      loading: true,
      records: [],
      total: 0
    };
  },
  props: {
    datatype: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapState({
      language: 'selectedLanguage',
      models: 'models',
      workspace: 'workspace',
      isSessionLoaded: 'isSessionLoaded',
      viewReload: 'viewReload',
      awsExports: 'awsExports'
    }),
    limit() {
      return this.$store.state.AdminUserStore.pagination.find((item) => item.datatype === this.datatype)?.limit;
    },
    offset() {
      return this.$store.state.AdminUserStore.pagination.find((item) => item.datatype === this.datatype)?.offset;
    },
    sort() {
      return this.$store.state.AdminUserStore.sort.find((item) => item.datatype === this.datatype)?.sort || 'ASC';
    },
    query() {
      return this.$store.state.AdminUserStore.query.find((item) => item.datatype === this.datatype)?.query;
    }
  },
  mounted() {
    if (this.isSessionLoaded) {
      return this.fetch();
    }
  },
  watch: {
    isSessionLoaded(val) {
      if (val && this.isLoggedIn) {
        this.fetch();
      }
    },
    $route: {
      handler() {
        if (this.isSessionLoaded) {
          this.total = 0;
          this.fetch();
        }
      }
    },
    workspace: {
      handler() {
        if (this.isSessionLoaded) {
          return this.fetch();
        }
      }
    },
    language: {
      handler() {
        if (this.isSessionLoaded) {
          return this.fetch();
        }
      }
    },
    limit: {
      handler() {
        if (this.isSessionLoaded) {
          return this.fetch();
        }
      }
    },
    offset: {
      handler() {
        if (this.isSessionLoaded) {
          return this.fetch();
        }
      }
    },
    sort: {
      handler() {
        if (this.isSessionLoaded) {
          return this.fetch();
        }
      }
    },
    query: {
      handler() {
        if (this.isSessionLoaded) {
          return this.fetch();
        }
      }
    },
    viewReload: {
      handler() {
        if (this.isSessionLoaded && this.viewReload) {
          this.setViewReload(false);
          return this.fetch();
        }
      }
    }
  },
  methods: {
    ...mapMutations({
      setSnackbar: 'setSnackbar',
      setViewReload: 'setViewReload'
    }),
    async fetch(iteration = 1) {
      try {
        this.loading = true;
        const response = await this.$store.state.sdk.getDocuments({
          datatype: this.datatype,
          language: this.language,
          order: 'slug',
          limit: this.limit,
          offset: this.offset,
          sort: this.sort,
          query: this.query ?? '',
          destinationBucket: this.awsExports.Storage.AWSS3.publishedBucket
        });
        this.records = response.records ?? [];
        this.total = parseInt(response.total);
      } catch (e) {
        console.error(e);
        if (e instanceof DatabaseAsleepError && iteration <= 29) {
          this.setSnackbar({ message: this.$t('database.retry', { iteration }), error: 'error' });
          const updatedIteration = iteration + 1;
          return await this.fetch(updatedIteration);
        } else if (e instanceof DatabaseAsleepError) {
          this.setSnackbar({ message: this.$t('database.failed'), error: 'error' });
        } else {
          this.setSnackbar({ message: e, error: 'error' });
        }
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
